exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add_card{width:900px;}\n.mat-form-field-underline{bottom: 0 !important;}\nul{margin-bottom: 30px;}\n.cdk-overlay-backdrop{z-index: 1031 !important;}\n.cdk-overlay-container, .cdk-global-overlay-wrapper{z-index: 1031 !important;}\nbutton.popup_close { padding: 0; background: none; min-width: 10px; line-height: 5px; float: right; opacity: 0.4; margin-top: 5px;}\nh2{line-height: 27px;}\nh2.mat-dialog-title button{color: #222222;}\n.mat-input-container{font-size: 15px;}\nlabel{font-size: 13px; font-weight: bold;}\n.mat-select{margin-top:12px; }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/card-form/card-form.component.css
// module id = ../../../../../src/app/card-form/card-form.component.css
// module chunks = 39